import { ca } from '../i18n/ca';
import { blockedReason, type RatedServer } from './useRatedServers';

/**
 * The options of a server select, in the three groups the fit gives: every mod
 * the mission was made with, the terrain with other mods, and no terrain at all. Shared by
 * the mission page, where a session is made, and the session page, where its
 * server can still be changed until it starts (the owner, 2026-09-18).
 */
export function ServerOptions({
  rated,
  busyServers,
}: {
  rated: RatedServer[];
  busyServers: Set<string>;
}) {
  const fitServers = rated.filter((r) => r.fit.fit === 'exact');
  const almostServers = rated.filter((r) => r.fit.fit === 'partial');
  const unfitServers = rated.filter((r) => r.fit.fit === 'no');
  return (
    <>
      {fitServers.length > 0 && (
        <optgroup label={ca.missionUi.page.serversFit}>
          {fitServers.map(({ server: s, fit }) => {
            const blocked = blockedReason(s, fit, busyServers);
            return (
              <option key={s.id} value={s.id} disabled={blocked !== null}>
                {s.name} · {ca.access[s.access]}
                {blocked ? ` · ${blocked}` : ''}
              </option>
            );
          })}
        </optgroup>
      )}
      {almostServers.length > 0 && (
        <optgroup label={ca.missionUi.page.serversAlmost}>
          {almostServers.map(({ server: s, fit }) => {
            const blocked = blockedReason(s, fit, busyServers);
            return (
              <option
                key={s.id}
                value={s.id}
                disabled={blocked !== null}
                title={(fit.classes?.length ? fit.classes : fit.missing).join(', ')}
              >
                {s.name} · {ca.access[s.access]}
                {fit.classes?.length
                  ? ` · ${ca.missionUi.page.serverMissingClasses(fit.classes.length)}`
                  : fit.unread
                    ? ` · ${ca.missionUi.page.serverUnread}`
                    : fit.missing.length > 0
                      ? ` · ${ca.missionUi.page.serverMissingMods(fit.missing.length)}`
                      : ''}
                {blocked ? ` · ${blocked}` : ''}
              </option>
            );
          })}
        </optgroup>
      )}
      {unfitServers.length > 0 && (
        <optgroup label={ca.missionUi.page.serversUnfit}>
          {unfitServers.map(({ server: s }) => (
            <option key={s.id} value={s.id} disabled>
              {s.name} · {ca.access[s.access]} · {ca.missionUi.page.serverNoTerrain}
            </option>
          ))}
        </optgroup>
      )}
    </>
  );
}
